import { DEV } from 'esm-env';
import { ComponentType, ReactElement, memo, type ComponentProps } from 'react';
import SVGIllustration, { SVGProps } from './SVGIllustration';

type Props = Omit<SVGProps, 'src'>;
const createSvgIllustration = (
  src: ReactElement<ComponentProps<typeof SVGIllustration>>,
  displayName: string,
): ComponentType<Props> => {
  const Component = memo((props: Props) => {
    return <SVGIllustration {...props} src={src} />;
  });

  if (DEV) {
    Component.displayName = displayName;
  }

  return Component;
};

export default createSvgIllustration;
